<template>
  <div
    class="commoditydetail v-product"
    :class="{
      mounted
    }"
  >
    <div class="container">
      <div class="row v-product__content">
        <!-- 左侧图片部分 -->
        <div class="col-sm-6 commodityleft">
          <!-- 左侧图片媒体库展示, 屏幕大于sm展示 -->
          <template v-if="screenWidth >= screenWidthType.sm">
            <!-- 媒体库展示方式 -->
            <media-show
              :gallery-config="productConfig"
              :big-img="bigimg"
              :gallery="smallimg"
              :product="{ID: product.ID}"
              :product-info="product_info"
              :variant-new="variant_new"
              :activeIndex="activeIndex"
              @selected="selectcommodityimg"
            />
          </template>
          <!-- 移动端显示swiper -->
          <template v-else>
            <product-swiper
              class="v-product__swiper"
              :gallery="smallimg"
              :active-index="activeIndex"
              :product-res="{
                ID: product.ID
              }"
              pagination-style="number"
              :is-product="productTagList[product.ID]"
              :productInfo="{
                ...product_info,
                stock: variant_new.stock,
                sku: variant_new.sku
              }"
              @change="selectcommodityimg"
            />
          </template>
        </div>

        <!--右侧商品详情  -->
        <div class="col-sm-6 commodityright">
          <!-- 插件，主要内容部分 -->
          <div class="deploy"
            :class="{
              'deploy--left justify-content-start': productConfig.typographic_style === 'left',
              'deploy--center justify-content-center': productConfig.typographic_style === 'center',
            }"
          >
            <!-- 促销倒计时 -->
            <v-countdown
              class="deploy__countdown"
              v-if="count_down && count_down_show"
              :count_down="count_down"
              position="detail"
            ></v-countdown>
            <!-- css保留空格后整理代码格式产生的空格会有影响  切记 -->
            <h2
              class="deploy__title title_font2"
              style="white-space: pre-wrap"
              v-html="product.post_title"
            ></h2>
            <!-- 价格 -->
            <div class="deploy__price commoditypricetype">
              <v-selectprice
                :showCountryBefore="true"
                :show_regular_price_before="true"
                :country="$store.state.pricetype"
                :price="price"
                fontSize="18"
                :regular_price_num="regular_price"
                :disable_select="!(showCurrencySelector && currencySelectorType == 'global')"
                :appendToBody="false"
              ></v-selectprice>
            </div>

            <!-- buyxgetyShowLocation == 'price_down' -->
            <!-- 满送优惠 -->
            <v-buyx-gety
              class="deploy__buyx-gety"
              v-if="(buyxgetyShowLocation == 'price_down'|| !buyxgetyShowLocation )&& buyxgety_coupon.length"
              :buyxgety_coupon="buyxgety_coupon"
              :cart_type="cart_type"
              :show_currency_selector="true"
              theme="default"
              :add_cart_data="{ ...addproduct }"
              :buyxgety-setting="buyxgetySetting"
            ></v-buyx-gety>

            <v-line class="deploy__line" />

            <!-- 插件： 分享激励 -->
            <v-sharing-incentives
              class="deploy__incentives"
              theme="default"
              :product_res="product"
              :data="incentives_data"
              v-if="incentives_data && incentives_data.length"
            />

            <!-- 右侧商品详情变种 -->
            <template v-if="product.variants.length > 1">
              <!-- 插件：调色板 商品选择 -->
              <v-product-palette
                class="deploy__palette"
                type="detail"
                v-if="palette_config && palette_attrs && palette_attrs.length"
                :palette_attrs="palette_attrs"
                :variant_attrs="variant"
                :palette_config="palette_config"
                :variants_show_config="productConfig.variants_show_config"
                :smartShowAttrsName="true"
                :use_model_name="true"
              />
              <!-- 默认 商品选择 -->
              <div
                v-else
                class="commodityattribute"
                :class="productConfig.variants_show_config=='hollowlabel'?'hollowLable':''"
                v-for="(item, index) in variant_attrs"
                :key="item.name + index"
              >
                <p class="secondary_title">{{ item.name }}</p>
                <div v-if="productConfig.variants_show_config == 'label' || productConfig.variants_show_config == 'hollowlabel'">
                  <!-- 判断variant[index].value是否等于这个值是的话加active类名 -->
                  <div v-for="subitem in item.value" :key="item.name + index + subitem" style="display: inline-block">
                    <input
                      type="radio"
                      :name="variant[index].name"
                      v-model="variant[index].value"
                      :value="subitem"
                      class="secondary_title"
                      @click="changevariant(index, subitem)"
                      :id="item.name + index + subitem"
                    />
                    <label
                      class="secondary_title"
                      :class="[variant[index].value == subitem ? 'active' : '',themeStyleRadius == 'circle' ? 'button-radius' : '']"
                      :for="item.name + index + subitem"
                    >
                      <span>{{ subitem }}</span>
                    </label>
                  </div>
                </div>
                <div v-else>
                  <select :class="[themeStyleRadius == 'circle' ? 'button-radius' : '']" class="secondary_title" v-model="variant[index].value" @change="changevariant">
                    <option v-for="subitem in item.value" :key="subitem" :value="subitem">
                      {{ subitem }}
                    </option>
                  </select>
                </div>
              </div>
            </template>

            <!-- buyxgetyShowLocation == 'attr_down' -->
            <!-- 满送优惠 -->
            <v-buyx-gety
              class="deploy__buyx-gety"
              v-if="buyxgetyShowLocation == 'attr_down' && buyxgety_coupon.length"
              :buyxgety_coupon="buyxgety_coupon"
              :cart_type="cart_type"
              :show_currency_selector="true"
              theme="default"
              :add_cart_data="{ ...addproduct }"
              :buyxgety-setting="buyxgetySetting"
            ></v-buyx-gety>

            <!-- 右侧商品详情数量 -->
            <div class="addcart">
              <form onsubmit="return false">
                <!-- 自定义代码： 预留位 -->
                <div class="custom-form-properties"></div>
                <div class="deploy__commoditynum commoditynum secondary_title">
                  <div class="commoditynum__title">{{ $t('detail.quantity') }}</div>
                  <my-el-input-number
                    :class="[themeStyleRadius == 'circle' ? 'button-radius' : '']"
                    v-model="addproduct.quantity"
                    :step="1"
                    step-strictly
                    :max="100000"
                    :min="1"
                    @change="handleChange">
                  </my-el-input-number>
                </div>
                <!-- buyxgetyShowLocation == 'num_down' -->
                <!-- 满送优惠 -->
                <v-buyx-gety
                  class="deploy__buyx-gety"
                  v-if="buyxgetyShowLocation == 'num_down' && buyxgety_coupon.length"
                  :buyxgety_coupon="buyxgety_coupon"
                  :cart_type="cart_type"
                  :show_currency_selector="true"
                  theme="default"
                  :add_cart_data="{ ...addproduct }"
                  :buyxgety-setting="buyxgetySetting"
                ></v-buyx-gety>

                <!-- 插件： 自定义代码预留位 -->
                <div class="custom-form-properties"></div>

                <!-- 插件： 尺码插件 -->
                <v-size-chart
                  class="deploy__size-chart"
                  v-if="enable_size_chart"
                  :product_id="product.ID"
                />

                <!-- 插件：访客计数器 -->
                <v-show-visits class="deploy__visits" v-if="visitors" :data="visitors" theme="default" :style="{}"></v-show-visits>

                <!-- 营销：优惠码 -->
                <v-codedisplay
                  class="deploy__codedisplay"
                  theme="default"
                  v-if="code_display && code_display_show.length"
                  :code_display_show="code_display_show"
                ></v-codedisplay>
                <v-sellFeatures
                ></v-sellFeatures>
                <!-- 插件: 组合商品 -->
                <v-groupedproduct
                  class="deploy__group-product"
                  v-if="
                    add_group_products &&
                    (group_products_position == 'button_above') &&
                    group_product &&
                    group_product.length > 0
                  "
                  :price="price"
                  :group_product="group_product"
                  :group_product_all="group_product_all"
                  :regular_price="regular_price"
                  :stock="stock"
                  :loading="loading"
                  :getSymbolFromCurrency="getSymbolFromCurrency"
                  :smallimg="smallimg"
                  :variant_attrs="variant_attrs"
                  :variant="variant"
                  :product="product"
                  :cart_type="cart_type"
                  theme="Brooklyn"
                  :group_products_title="group_products_title"
                  :group_products_position="group_products_position"
                  :show_currency_selector="true"
                  :narrowerscreen="true"
                  :group_product_style="group_product_style"
                  :now_variant_computed_price="variant_new"
                  @checked_variants_info="checked_variants_info"
                ></v-groupedproduct>
                <!-- 按钮组 -->
                <div class="deploy__button-wrapper">
                  <!-- 购买按钮 -->
                  <el-button
                    class="gocart secondary_title addToCartAllThemeBtnClass"
                    :class="[
                      paypal_product_position == 'no' ? 'main_button' : 'minor_button',
                      themeStyleRadius == 'circle' ? 'button-radius' : '',
                    ]"
                    type="button"
                    native-type="submit"
                    :loading="loading"
                    v-if="stock"
                    v-show="hide_add_btn !== true"
                    @click="!loading && addcart('athenaGroupProduct')"
                  >
                    <i class="iconfont icon-24gf-cart7" />
                    {{ $t('detail.add_to_cart') }}
                  </el-button>

                  <!-- 售罄按钮 -->
                  <el-button
                    v-else
                    v-show="hide_add_btn !== true"
                    class="gocart soldout secondary_title"
                    type="button"
                    disabled
                    :class="[themeStyleRadius == 'circle' ? 'button-radius' : '']"
                  >
                    {{ $t('detail.sold_out') }}
                  </el-button>

                  <!-- 立即购买 -->
                  <el-button
                    class="buynow main_button secondary_title"
                    v-if="button_type == 'buynow'"
                    :loading="loading"
                    v-show="stock"
                    :class="[themeStyleRadius == 'circle' ? 'button-radius' : '']"
                    @click="!loading && addcart('buynow')"
                  >
                    {{ $t('detail.but_it_now') }}
                  </el-button>

                  <!-- 贝宝按钮 -->
                  <v-paypal-btn
                   v-if="button_type == 'paypal'"
                    v-show="stock"
                    :addproduct="JSON.stringify(addproduct)"
                    :group_checked_variants_info="group_checked_variants_info?JSON.stringify(group_checked_variants_info):'[]'"
                  ></v-paypal-btn>
                  <div  v-if="button_type == 'paypal'" class="text-center deploy__button-wrapper--paypal_but_it_now">
                    <span @click="!loading && addcart('buynow')">
                      {{ $t('add.more_payment_options') }}
                    </span>
                  </div>

                  <!-- 自定义按钮 -->
                  <v-custom-button
                    v-if="custom_button && custom_button.is_detail_page == '1'"
                    :custom_button="custom_button"
                  ></v-custom-button>
                </div>

                <!-- 营销: 梯度优惠 -->
                <v-bulk-coupon
                  class="deploy__bulk-coupon"
                  v-if="has_bulk_coupon"
                  :cart_type="cart_type"
                  :stock="stock"
                  :bulk_coupon="bulk_coupon"
                  :product_id="addproduct.product_id"
                  :variant_id="addproduct.variant_id"
                  theme="Brooklyn"
                  :product="product"
                ></v-bulk-coupon>

                <!-- 插件: 组合商品。显示在按钮之后 -->
                <v-groupedproduct
                  class="deploy__group-product"
                  v-if="
                    add_group_products &&
                    (group_products_position == 'button below' || group_products_position == 'above') &&
                    group_product &&
                    group_product.length > 0
                  "
                  :price="price"
                  :group_product="group_product"
                  :group_product_price_rules="group_product_price_rules"
                  :group_product_all="group_product_all"
                  :regular_price="regular_price"
                  :stock="stock"
                  :loading="loading"
                  :getSymbolFromCurrency="getSymbolFromCurrency"
                  :smallimg="smallimg"
                  :variant_attrs="variant_attrs"
                  :variant="variant"
                  :product="product"
                  :cart_type="cart_type"
                  theme="Brooklyn"
                  :group_products_title="group_products_title"
                  group_products_position="button below"
                  :show_currency_selector="true"
                  :narrowerscreen="true"
                  :group_product_style="group_product_style"
                ></v-groupedproduct>
              </form>
            </div>
          </div>

          <!-- 右侧商品详情公共部分 -->
          <div class="default_css">
            <!-- 商品详情 -->
            <div
              v-html="this.re_remover_class(product.post_content)"
              class="tinymce-content post_content page_text_font"
            ></div>

            <!-- 插件： 组合商品 -->
            <v-groupedproduct
              v-if="
                add_group_products && group_products_position == 'right' && group_product && group_product.length > 0
              "
              :price="price"
              :group_product="group_product"
              :group_product_price_rules="group_product_price_rules"
              :group_product_all="group_product_all"
              :regular_price="regular_price"
              :stock="stock"
              :loading="loading"
              :getSymbolFromCurrency="getSymbolFromCurrency"
              :smallimg="smallimg"
              :variant_attrs="variant_attrs"
              :variant="variant"
              :product="product"
              :cart_type="cart_type"
              theme="Brooklyn"
              :group_products_title="group_products_title"
              group_products_position="right"
              :show_currency_selector="true"
              :narrowerscreen="true"
              :group_product_style="group_product_style"
            ></v-groupedproduct>
          </div>

          <!-- 装修->设置：分享按钮 -->
          <v-product-share
            :product_res="product"
            :share_event="share_event"
            :show_name="true"
          ></v-product-share>
        </div>

        <div v-if="collectionsid != slug" class="col-12 text-center backcollection">
          <a class="secondary_title" :href="'/collections/' + collectionsid" @click.prevent="backcollection"
            >← {{ $t('detail.back_to') }} {{ name.toString().toUpperCase() }}</a
          >
        </div>
      </div>

      <!-- group_products_position=='below'&& -->
      <!-- 组合商品 -->
      <v-groupedproduct
        v-if="add_group_products && group_products_position == 'below' && group_product && group_product.length > 0"
        :price="price"
        :group_product="group_product"
        :group_product_price_rules="group_product_price_rules"
        :group_product_all="group_product_all"
        :regular_price="regular_price"
        :stock="stock"
        :loading="loading"
        :getSymbolFromCurrency="getSymbolFromCurrency"
        :smallimg="smallimg"
        :variant_attrs="variant_attrs"
        :variant="variant"
        :product="product"
        :cart_type="cart_type"
        theme="Brooklyn"
        :group_products_title="group_products_title"
        group_products_position="below"
        :show_currency_selector="true"
        :narrowerscreen="true"
        :group_product_style="group_product_style"
      ></v-groupedproduct>
    </div>

    <!-- 推荐商品 -->
    <v-guess-like
      :comment="comment"
      v-if="recommended_product && show_recommended"
      :show_currency_selector="false"
      :recommended_product="recommended_product"
      :cart_type="cart_type"
      :product_id="product.ID"
      :palette_config="palette_config"
      theme="Brooklyn"
    ></v-guess-like>

    <!-- 商品评论 -->
    <v-comments
      v-if="comment"
      :comment="comment"
      :review_count="product.review_count"
      :average_rating="product.average_rating"
      :rating_count="product.rating_count"
      :product_id="product.ID"
    ></v-comments>

    <div class="container">
      <v-groupedproduct
        v-if="add_group_products && group_products_position == 'foot' && group_product && group_product.length > 0"
        :price="price"
        :group_product="group_product"
        :group_product_price_rules="group_product_price_rules"
        :group_product_all="group_product_all"
        :regular_price="regular_price"
        :stock="stock"
        :loading="loading"
        :getSymbolFromCurrency="getSymbolFromCurrency"
        :smallimg="smallimg"
        :variant_attrs="variant_attrs"
        :variant="variant"
        :product="product"
        :cart_type="cart_type"
        theme="Brooklyn"
        :group_products_title="group_products_title"
        group_products_position="foot"
        :show_currency_selector="true"
        :narrowerscreen="true"
        :group_product_style="group_product_style"
      ></v-groupedproduct>
    </div>

    <!-- 快捷加购 -->
    <v-new-quick-add-cart
      :quick-add-cart="quickAddCart"
      v-if="quick_add_cart"
      :show-quick-add-cart="quick_add_cart"
      :variant-new="variant_new"
      :product="product"
      :stock="stock"
      :price="price"
      :regular-price="regular_price"
      :loading="loading"
      :variant-attrs="variant_attrs"
      :current-variant="variant"
      :addproduct="addproduct"
      @fatherMethod="addcart"
      :show-currency-selector="true"
    ></v-new-quick-add-cart>
  </div>
</template>

<script>
// import API from '@/js/API.js'
import getSymbolFromCurrency from 'currency-symbol-map'
import vGroupedproduct from '@/js/components/view/groupedproduct/index'
import vGuessLike from '@/js/components/view/guesslike/guesslike'
import vBulkCoupon from '@/js/components/common/bulkcoupon'
import vBuyxGety from '@/js/components/view/buyxgety/index'
import vSharingIncentives from '@/js/components/applications/SharingIncentives/index.vue'
import vShowVisits from '@/js/components/view/showvisits'
import vSizeChart from '@/js/components/applications/SizeChart'
import { mapActions, mapState } from 'vuex'
import googleAnalysis from '@/js/lib/ga'
import mixGroupProduct from '@/js/mixins/mixGroupProduct'
import mixProductTag from '@/js/mixins/mixProductTag'
import MediaCard from '@/js/components/MediaCard.vue'
import vNewQuickAddCart from '@/js/components/view/quickaddcart/newQuickAddCart.vue'
import mixProperties from '@/js/mixins/mixProperties'
import vProductShare from '@/views/venue/js/view/product/productShare.vue'
import { screenWidthType } from '@/js/lib/settings'
import MediaShow from '@/js/components/Product/MediaShow.vue'
import ProductSwiper from '@/js/components/ProductSwiper/index.vue'
import vProductPalette from '@/js/components/view/productpalette/index.vue'
import vCountdown from '@/js/components/common/countdown.vue'
import vCodedisplay from '@/js/components/view/codedisplay/index.vue'
import myElInputNumber from "@/js/components/myElement/myElInputNumber.vue"

export default {
  name: 'product',
  props: [
    'name',
    'group_product_all',
    'collectionsid',
    'slug',
    'product',
    'variant_attrs',
    'count_down',
    'quick_add_cart',
    'comment',
    'add_group_products',
    'group_products_title',
    'group_products_position',
    'recommended_product',
    'code_display',
    'sharing_incentives',
    'is_custom_button',
    'palette_config',
    'visitors_counter',
    'product_tag',
    'enable_size_chart',
    'group_product_style',
    'quickAddCart',
  ],
  data() {
    return {
      notNextTick: true,
      swiperOption: {
        autoHeight: true,
        loop: true,
      },
      getSymbolFromCurrency: '',
      // featureImageId: '', //变种商品图片ID
      regular_price: '',
      price: this.product.price,
      bigimg: {},
      smallimg: [],
      addproduct: {
        quantity: '1',
        product_id: '',
      },
      loading: false,
      variant: [], //根据变种属性name创建一个数组variant，value为变种属性的第一个值
      stock: false,
      variant_new: '',
      quick: false, //快速结账开关
      count_down_show: false, //促销倒计时开关
      show_recommended: false,
      variant_id: null,
      has_bulk_coupon: false,
      bulk_coupon: {},
      buyxgety_coupon: [],
      incentives_data: [],
      code_display_show: [],
      visitors: null,
      palette_attrs: [],
      custom_button: null,
      hide_add_btn: false,
      regularPrice: 0, //产品卡片标签的原价格
      activeIndex: 0, // 选中的图片
      activeImgData: {},
      buyxgetySetting: {}, //满送优惠设置
      buyxgetyShowLocation:null, //满送优惠显示的位置
      group_checked_variants_info: [], //存放组合商品数据
      screenWidthType,
      mounted: false
    }
  },
  mixins: [mixGroupProduct, mixProductTag, mixProperties],
  methods: {
    ...mapActions({
      get_product_tag: 'change_product_tag_list', // 将 `this.get_product_tag()` 映射为 `this.$store.dispatch('change_product_tag_list')`
    }),
    handleChange(e) {
      let quantity = this.filterinputnum(e)
      this.addproduct.quantity = quantity
    },
    handleScroll() {
      // console.log(window.pageYOffset)
      if (window.pageYOffset > 760) {
        this.$('.quickPurchased').slideDown(300)
      } else {
        this.$('.quickPurchased').slideUp(300)
      }
      // console.log('quick',this.quick);
    },
    async share_event(e) {
      try {
        let res = await this.$axios.post(API.statis_event, {
          name: 'shares.' + e,
          parameters: { url: window.location.href },
        })
        console.log(res)
      } catch (error) {
        console.log(error.response)
      }
    },
    backcollection() {
      console.log('huitui')
      window.history.back()
    },

    // todo 不知道是干嘛的
    gotvariant(item) {
      if ( item.buy_able ) {
        this.stock = true
      } else {
        this.stock = false
      }

      // 第一次进来不url不拼接参数
      if (this.search_add_id_on) {
        window.history.replaceState({}, '', this.replaceSearch('variant', item.ID, true))
      } else {
        this.search_add_id_on = true
      }

      // 这个变种商品如果有图片则把这张图赋给bigimg,并且修改featureImageId来给gallery添加active
      if (item.feature_image) {
        this.bigimg = item.feature_image

        const featureImageId = item.feature_image.ID
        this.$store.dispatch('change_feature_image_id', featureImageId)

        this.smallimg.some((flatitem, flatindex) => {
          if (flatitem.ID == featureImageId) {
            this.activeIndex = flatindex
            // 移动平铺照片的首个
            if (this.$store.state?.screenWidth > 768 && this.productConfig.gallery_show_config == 'flat') {
              this.smallimg.unshift(this.smallimg.splice(flatindex, 1)[0])
            }
            return true;
          }
        })
      } else {
        this.$store.dispatch('change_feature_image_id', 0)
        this.activeIndex = 0
        this.featureImageId = 0
      }

      this.variant_new = item

      console.log('variant_new', this.variant_new)

      //在改变变种商品时获取该变种的属性赋值给产品卡片标签
      this.regularPrice = item.regular_price

      this.$store.dispatch('change_now_variant', this.variant_new)
      this.addproduct.variant_id = item.ID
      this.price = item.price
      //判断这个变种商品的regular_price存在吗,如果存在就regular_price且大于现价就显示原价,不存在就为0;
      this.regular_price = item.regular_price && item.regular_price - 0 > item.price - 0 ? item.regular_price : false
      return true
    },
    // 当绑定于variant中的值改变后判断整个variant和变种商品中那个attrs相同来获取该变种商品的id
    changevariant(index, value) {
      if (index != undefined && value != undefined) {
        this.variant[index].value = value
      }
      // 如果只有一个index参数时候则代表有查询参数variant，此时根据variant_id获取变种商品，并改变变种规格。
      if (index != undefined && value == undefined) {
        let variant_res = this.product.variants.some((item) => {
          if (item.ID == index) {
            this.variant.forEach((variant_item) => {
              item.attrs.some((attrs_item) => {
                if (variant_item.name == attrs_item.name) {
                  variant_item.value = attrs_item.value
                  return true
                }
              })
            })
            return this.gotvariant(item)
          }
        })
        // 如果判断出结果则终止这个函数。如果查询参数有误则继续函数，按默认的方式走；
        if (variant_res) {
          return
        }
      }
      this.product.variants.some((item) => {
        let res = item.attrs.every((subitem) => {
          return this.variant.some((lowitem) => {
            return lowitem.name == subitem.name && lowitem.value == subitem.value
          })
        })
        //判断出是哪个个变种商品了
        if (res) {
          return this.gotvariant(item)
        } else {
          this.stock = false
        }
      })
    },

    /**
     * 点击选择缩略图
     */
    selectcommodityimg(index) {
      // 不知道是干嘛的
      this.$store.dispatch('change_feature_image_id', 0)

      this.activeIndex = index
      this.bigimg = this.smallimg[index]
    },
    async addcart(buynow,onlySelf=false) {
      try {
        this.addproduct.quantity = this.addproduct.quantity || 1
        this.addproduct.quantity = this.addproduct.quantity > 100000 ? 100000 : this.addproduct.quantity
        let payload = { ...this.addproduct,addType:"product.add" }
        let api = API.addcart;
        if((buynow === 'athenaGroupProduct' || buynow === 'buynow') && this.group_checked_variants_info?.length > 0) {
          payload = { addType:'product.batchCart'};
          api = API.batchCart;
          payload.product = [];
          payload.product.push(...[{ ...this.addproduct }],...(!onlySelf ? this.group_checked_variants_info:[]));
        }
        let customFormProperties = this.mixProperties()
        let filesOff = false
        if (customFormProperties && api == API.addcart) {
          let { files, properties, resume } = customFormProperties
          if (!resume) {
            return
          }
          filesOff = files && Object.keys(files).length
          let propertiesOff = properties && Object.keys(properties).length
          if (filesOff) {
            let formData = new FormData()
            for (const key in files) {
              for (const subKey in files[key]) {
                if (Object.hasOwnProperty.call(files[key], subKey)) {
                  formData.append(`properties[${key}]`, files[key][subKey])
                }
              }
            }
            if (propertiesOff) {
              for (const key in properties) {
                formData.append(`properties[${key}]`, properties[key])
              }
            }
            for (const key in payload) {
              formData.append(key, payload[key])
            }
            payload = formData
          } else if (propertiesOff) {
            payload.properties = properties
          }
        }
        // 批量加购自定义属性处理
        if (customFormProperties && api == API.batchCart) {
          let { files, properties } = customFormProperties;
          let formData = new FormData();
          filesOff = files && Object.keys(files).length
          let propertiesOff = properties && Object.keys(properties).length
          if (filesOff) {
              payload.product.forEach((item, index) => {
                  formData = parseFormDate(`product[${index}][properties]`, files, properties, item, `product[${index}]`, formData);
              })
              payload = formData;
          } else if (propertiesOff) {
              let newArr = payload.product.map(item => {
                  return { ...item, properties: properties }
              });
              payload.product = newArr;
          }
        }
        this.loading = true
        if (buynow == 'buynow') {
          if (filesOff) {
            payload.append('clear', 1)
            payload.append('addType', 'product.buynow')
          } else {
            payload.clear = true
            payload.addType = 'product.buynow'
          }
        }
        let res = await this.$axios.post(api, payload)
        this.$store.dispatch('change_news_cart', res.data)
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
        if(res.data){
          this.$store.commit("change_button_disabled", true);
        }
        if (window.fbq) {
          let content_category = []
          if (this.product.categories && this.product.categories.length) {
            this.product.categories.forEach((item) => {
              content_category.push(item.name)
            })
          }
          this.send_fb_event('AddToCart', {
            content_type: 'product_group',
            content_ids: [this.addproduct.product_id],
            value: this.variant_new.price,
            num_items: this.addproduct.quantity,
            content_name: this.variant_new.title,
            currency: res?.data?.currency,
            content_category,
          })
        }
        if (window.ttq && window.send_ttp_event) {
          window.send_ttp_event('AddToCart', {
            content_id: [this.addproduct.product_id],
            quantity: this.addproduct.quantity,
            value: this.variant_new.price,
            currency: window.checkoutcurrency || 'USD',
          })
        }
        if (window._learnq) {
          this.klaviyo_addtocart(this.product, this.addproduct)
        }

       // 记录snapchat事件
        if (window.snaptr) {
          window.snaptr('track', 'ADD_CART', {
            'currency': res?.data?.currency,
            'item_category': null,
            'item_ids': [this.addproduct.product_id],
            'number_items': this.addproduct.quantity,
            'price': this.variant_new.price,
          })
        }

        // 发送谷歌分析
        googleAnalysis.event('add', {
          value: this.variant_new?.price,
          currency: res?.data?.currency,
          items: [
            {
              id: this.addproduct?.product_id,
              name: this.variant_new?.title,
              category: this.product.categories?.[0]?.name,
              price: this.variant_new?.price,
              quantity: this.addproduct?.quantity,
              variant: this.variant?.[0]?.value,
            },
          ],
        })

        if (buynow == 'buynow') {
          this.cart_hash = this.getCookie('cart_hash')
          this.toCheckInfo(this.cart_hash)
          // window.open(
          //   `/checkouts/${this.cart_hash}?step=contact_information`,
          //   "_self"
          // );
        } else if (this.cart_type == 'drawer') {
          this.loading = false
          this.$store.commit("change_button_disabled", false);
          this.$store.dispatch('change_cart_type', true)
        } else {
          //window.open('/cart', '_self')
          setTimeout(() => {
            this.loading = false
            this.$store.commit("change_button_disabled", false);
          }, 800)
        }
        setTimeout(() => {
          this.loading = false
          this.$store.commit("change_button_disabled", false);
        }, 5000)
      } catch (error) {
        this.loading = false
        this.$store.commit("change_button_disabled", false);
        if (error?.response?.data?.errors) {
          this.$message.error(Object.values(error.response.data.errors)[0][0])
        } else {
          this.$message.error(error?.response?.data?.message || error?.message)
        }
      }
    },
    // 获取选中的组合商品
    checked_variants_info(payload) {
      this.group_checked_variants_info = payload;
    },
  },
  beforeMount() {
    this.variant_id = this.getSearch('variant=')
    if (this.recommended_product) {
      console.log(this.recommended_product)
      this.show_recommended = !this.recommended_product.shieldProduct.includes(this.product.ID)
    }
    if (this.count_down) {
      this.count_down_show =
        this.count_down.detail.type == 'all' ||
        this.count_down.detail.product_ids.includes(this.product.ID) ||
        this.count_down.detail.category_ids.some((item) => {
          return this.product.categories.some((subitem) => {
            return subitem.id == item
          })
        })
    }
    console.log('count_down_show', this.count_down_show)
    this.getSymbolFromCurrency = getSymbolFromCurrency
    this.variant_new = this.product
    this.regular_price =
      this.product.regular_price && this.product.regular_price - 0 > this.product.price - 0
        ? this.product.regular_price
        : false
    this.addproduct.product_id = this.product.ID

    // 获取产品的主图
    if (this.product.feature_image) {
      this.bigimg = this.product.feature_image
      this.featureImageId = this.product.feature_image.ID
    } else if(this.product.gallery && this.product.gallery.length ) {
      this.bigimg = this.product.gallery[0];
    } else {
      this.bigimg = {
        thumbnail: this.defaultImage,
        url: this.defaultImage,
      }
    }

    //如果相册没有图片的话
    //给轮播图添加一张图片
    if (!this.product.gallery.length) {
      this.smallimg.push({
        ID: 'defaultImage',
        thumbnail: this.defaultImage,
        url: this.defaultImage,
      })
    }

    // 将商品所有图片添加到左侧小图中
    this.smallimg.push(...this.product.gallery)
    // 若有变种属性则根据变种属性name创建一个数组variant，value为变种属性的第一个值，该数组同时可用与单选框绑定属性
    if (this.variant_attrs.length) {
      this.variant_attrs.forEach((item) => {
        this.variant.push({
          name: item.name,
          value: item.value[0],
        })
      })
    } else {
      //判断有没有库存
      if (this.product.buy_able) {
        this.stock = true
      }
    }
    this.$axios.get(API.get_coupons + this.product.ID).then((res) => {
      let { bulk_coupon, buyxgety_coupon, setting } = res.data
      if (bulk_coupon) {
        this.bulk_coupon = bulk_coupon
        this.has_bulk_coupon = true
      }
      if (buyxgety_coupon) {
        this.buyxgety_coupon = buyxgety_coupon
      }
      if (setting) {
        this.buyxgetySetting = setting
        this.buyxgetyShowLocation = setting?.show_local
      }
    })
    if (this.code_display) {
      this.$axios.get(API.get_code_display + this.product.ID).then((res) => {
        this.code_display_show = res.data
      })
    }
    if (this.sharing_incentives) {
      this.$axios.get(API.incentives + this.product.ID).then((res) => {
        const { data } = res.data
        this.incentives_data = data
        console.log('sharing_incentives', res, data)
      })
    }
    if (this.is_custom_button) {
      this.hide_add_btn = true
      this.$axios
        .get(API.custom_button, {
          params: { product_ids: this.product.ID },
        })
        .then((res) => {
          this.custom_button = res.data[0].custom_button
          let { is_cart_detail_page } = this.custom_button
          this.hide_add_btn = !!is_cart_detail_page
          console.log('isDataDataData', res.data)
        })
    }
    if (this.visitors_counter) {
      this.$axios.get(API.visitors_counter + this.product.ID).then((res) => {
        this.visitors = res.data
      })
    }
    if (this.palette_config) {
      let params = {
        'filter[product_id]': this.product.ID,
      }
      this.$axios.get(API.palette, { params }).then((res) => {
        if (res && res.data && res.data[this.product.ID]) this.palette_attrs = res.data[this.product.ID]
      })
    }
  },
  mounted() {
    // 挂载
    this.mounted = true;
    const skeletonDom = document.getElementsByClassName("product-skeleton");
    // 直接删除元素
    skeletonDom?.[0]?.remove();

    if (this.variant_attrs.length && this.variant_id) {
      // 设置变种属性默认值后先获取一遍变种id
      this.changevariant(this.variant_id)
    }

    this.send_fb_event('ViewContent', {
      content_type: 'product_group',
      content_ids: [this.product.ID],
      value:
        this.product['variants'] && this.product['variants'].length
          ? this.product['variants'][0]['price']
          : this.product['price'],
      content_name:
        this.product['variants'] && this.product['variants'].length
          ? this.product['variants'][0]['title']
          : this.product['title'],
      currency: window.checkoutcurrency,
      content_category:
        this.product['categories'] && this.product['categories'].length ? this.product['categories'][0]['name'] : '',
    })
    this.send_ttp_event('ViewContent', {
      content_type: 'product_group',
      content_id: [this.product.ID],
      value:
        this.product['variants'] && this.product['variants'].length
          ? this.product['variants'][0]['price']
          : this.product['price'],
      currency: window.checkoutcurrency,
    })
    if (this.product_tag) {
      this.get_product_tag(this.product.ID)
    }

    // 浏览页面
    googleAnalysis.event('detail', {
      items: [
        {
          id: this.product?.ID,
          name: this.product?.post_title,
          brand: '',
          category: this.product?.categories?.[0]?.name,
          price: this.price,
          variant: this.variant?.[0]?.value,
        },
      ],
    })
  },
  created() {
    this.bus.$on('get_variant', (res) => {
      this.variant[res.index].value = res.val
    })
  },
  watch: {
    variant: {
      handler(newName, oldName) {
        this.changevariant()
      },
      immediate: false,
      deep: true,
    },
  },
  computed: {
    ...mapState({
      showCurrencySelector: ({ options }) => !options?.theme?.global?.show_currency_selector,
      productConfig: ({ options }) => {
        const product = options?.theme?.pages?.product || {}
        const config = product?.config || {}
        // 历史问题,配置可能是这样的： product: { gallery_show_config: '', variants_show_config: '' }
        const galleryShowConfig = product?.gallery_show_config || config.gallery_show_config
        const variantsShowConfig = product?.variants_show_config || config.variants_show_config

        return {
          ...config,
          gallery_show_config: galleryShowConfig,
          variants_show_config: variantsShowConfig
        }
      },
      isMobile: ({ isMobile }) => isMobile,
      screenWidth: ({ screenWidth }) => screenWidth,
      showCurrencySelector: ({ options }) => options?.theme?.global?.show_currency_selector,
      currencySelectorType: ({ options }) => options?.theme?.global?.currency_selector_type,
      // 主题风格
      themeStyleRadius: ({ options }) => options?.theme?.global?.style?.type || "",
      productTagList: (state) => state.product_tag_list,
      paypal_enabled: ({ options }) => options.base?.preferred_paypal_payment_method,
      paypal_product_position: ({ options }) => options.base?.paypal_product_position,
      cart_type: ({ options }) => options.theme?.global?.cart?.type,
      socialMedias: ({ options }) => options.theme?.global?.social_medias,
    }),
    enable_facebook() {
      return this.socialMedias?.enable_facebook
    },
    enable_twitter() {
      return this.socialMedias?.enable_twitter
    },
    enabel_pinterest() {
      return this.socialMedias?.enabel_pinterest
    }
  },
  components: {
    myElInputNumber,
    vBulkCoupon,
    vGroupedproduct,
    vGuessLike,
    vBuyxGety,
    vSharingIncentives,
    vShowVisits,
    vSizeChart,
    [MediaCard.name]: MediaCard,
    vNewQuickAddCart,
    vProductShare,
    MediaShow,
    ProductSwiper,
    vProductPalette,
    vCountdown,
    vCodedisplay,
  },
}
</script>
<style lang='scss'>
.v-product {
  position: fixed;
  z-index: -100;
  opacity: 0;
  height: 0;
  transition: all 0.4s;
  &.mounted {
    height: auto;
    position: unset;
    z-index: unset;
    opacity: 1;
  }
  // 标题
  @mixin title {
    font-size: 16px;
    line-height: 24px;
  }
  // 详情页模块
  @mixin deployModule {
    margin-top: 0;
    margin-bottom: 20px;
    width: 100%;
    text-align: var(--text-aligin);
  }

  &__content {
    margin-left: -40px;
    margin-right: -40px;
    display: flex;
    flex-wrap: wrap;
    .commodityleft, .commodityright {
      padding-left: 40px;
      padding-right: 40px;
    }
    .commodityright {
      .deploy {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-items: center;
        text-align: center;
        --text-aligin: center;
        &__countdown {
          @include deployModule;
        }
        &__title {
          // font-size: 24px; 字体大小由后台设置，不要强制定义
          line-height: 1.5;
          margin-bottom: 20px;
        }
        // 价格
        &__price {
          font-size: 18px;
          line-height: 27px;
          margin-bottom: 20px;
          ::v-deep {
            .regular_price {
              margin-right: 10px;
              font-size: 18px;
              text-decoration: line-through;
            }
            .tax {
              margin: 15px 0 0 0;
              font-weight: 400;
              font-size: 15px;
              color: #222323;
            }
          }
        }
        // 数量选择按钮
        &__commoditynum {
          .button-radius {
            border: 1px solid #d2d2d2;
            input {
              border: 0;
            }
          }
          .el-input-number {
            width: 140px;
            height: 40px;
            font-size: 18px;
            font-weight: 600;
            color: #222A40;
            &__decrease,
            &__increase {
              background-color: #fff;
              border-radius: 0;
              &:hover {
                color: #666;
                &:not(.is-disabled) {
                  &~.el-input {
                    .el-input {
                      &__inner {
                        &:not(.is-disabled) {
                          border-color: #d2d2d2;
                        }
                      }
                    }
                  }
                }
                &~.el-input {
                  &__inner {
                    border-color: #d2d2d2;
                  }
                }
              }
            }
            .el-input {
              &__inner {
                border-color: #d2d2d2;
                border-radius: 0;
              }
            }
          }
        }
        // 满送优惠
        &__buyx-gety {
          @include deployModule;
          display: inline-block;
          .buyxgety {
            margin: 0;
            display: inline-block;
            text-align: left;
          }
        }
        // 横线
        &__line {
          display: inline-block;
          height: 1px;
          margin-top: 0;
          margin-bottom: 20px;
          width: 50px;
          background-color: #222323;
        }
        // 分享激励
        &__incentives {
          margin-bottom: 10px;
        }
        // 插件：调色板
        &__palette {
          margin-bottom: 0;
          margin-top: 0;
          width: 100%;
          .variant-select {
            margin-bottom: 10px;
            &__title {
              margin-bottom: 12px;
              font-size: 16px;
              line-height: 24px;
            }
          }
          .labelStyleBox {
            .labelStyle {
              justify-content: center !important;
            }
          }
          .palette-select {
            .select-value {
              display: inline-block;
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
        // 加购部分
        .commoditynum {
          margin-bottom: 20px;
          font-size: 15px;
          &__title {
            @include title;
            margin-bottom: 12px;
          }
        }
        // 插件: 尺码表
        &__size-chart {
          margin-bottom: 20px;
          text-align: var(--text-aligin);
          .size-chart {
            &__title {
              @include title;
              margin-bottom: 12px;
            }
          }
        }
        // 插件：访客计数
        &__visits {
          @include deployModule;
          margin: 0 !important;
          margin-top: 0 !important;
          margin-bottom: 20px !important;
          max-width: unset
        }
        // 插件：优惠券
        &__codedisplay {
          @include deployModule;
          .manner {
            display: inline-block;
            &:first-child {
              margin-top: 0 !important;
            }
          }
        }
        // 插件：组合商品
        &__group-product {
          @include deployModule;
        }
        // 按钮组
        &__button-wrapper {
          @include deployModule;
          .el-button {
            margin-top: 0;
            margin-bottom: 14px;
            height: 48px;
          }
          // 贝宝按钮
          .paypal-button-render {
            margin-top: 0;
            margin-bottom: 14px;
            z-index: 1;
          }
          &--paypal_but_it_now{
            width: 100%;
            text-decoration: underline;
            font-style: italic;
            font-size: 14px;
            font-family: var(--text-font-family);
            span{
              cursor: pointer;
            }
          }
        }
        // 营销： 梯度优惠
        &__bulk-coupon {
          @include deployModule;
        }
        .addcart {
          width: 100%;
        }

        // 居左显示
        &--left {
          --text-aligin: left;
          text-align: left;
          align-items: flex-start;
          .deploy {
            &__incentives {
              margin: 0;
              margin-bottom: 10px;
            }
            // 插件：调色板
            &__palette {
              .labelStyleBox {
                .labelStyle {
                  justify-content: flex-start !important;
                }
              }
            }
          }
        }
      }
      .default_css {
        overflow: hidden;
      }
    }
  }
  &__swiper {
    margin-left: -15px;
    margin-right: -15px;
    margin-bottom: 0;
  }
  @media screen and (max-width: 1225px) {
    &__content {
      margin-left: -15px;
      margin-right: -15px;
      .commodityleft {
        padding-right: 40px;
        padding-left: 15px;
      }
      .commodityright {
        padding-right: 15px;
        padding-left: 40px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    &__content {
      margin-left: -15px;
      margin-right: -15px;
      .commodityleft,  .commodityright {
        padding-left: 15px;
        padding-right: 15px
      }
    }
  }
  // 移动端
  @media screen and (max-width: 575px) {
    &__content {
      .commodityleft {
        margin-bottom: 20px;
      }
      .commodityright {
        .deploy {
          &__countdown {
            width: calc(100% + 30px);
            margin-left: -15px;
            margin-right: -15px;
          }
        }
      }
    }
  }
}
.product-groups {
  margin: 20px 0;
}
.commoditydetail {
  margin-top: 60px;
  .container {
    .commodityleft {
      .backcollection {
        margin-top: 50px;
        a {
          text-decoration: none;
          color: #000;
          font-size: 14px;
        }
      }
      .v-media-card__media {
        img {
          width: 100%;
        }
      }
    }

    .commodityright {
      div {
        .default_css {
          overflow: hidden;
          position: relative;
          img,
          iframe,
          video {
            max-width: 100% !important;
          }
          pre {
            white-space: pre-wrap;
          }
          .post_content {
            overflow-x: auto;
          }
        }
        .social-sharing {
          text-align: center;
          margin-top: 50px;
          span {
            margin-left: 10px;
            cursor: pointer;
            font-size: 14px;
            -webkit-tap-highlight-color: rgba(23, 178, 235, 0.3) !important;
          }
          span:hover {
            opacity: 0.7;
          }
        }
      }
      .deploy {
        .variant_attrs_box {
          .variant_select {
            .palette-detail {
              margin-bottom: 15px;
            }
          }
        }
        .commodityattribute.hollowLable{
          label{
            border: unset;
            color: var(--main-btn-bg);
            &.active {
              border: 1px solid var(--main-btn-bg);
              background-color: unset;
            }
          }
        }
        .commodityattribute {
          margin-bottom: 13px;
          width: 100%;
          p {
            font-size: 15px;
            margin-bottom: 10px;
          }
          label {
            display: inline-block;
            font-family: 'OpenSans-Regular', sans-serif;
            font-weight: 600;
            font-style: normal;
            letter-spacing: 0.1em;
            // text-transform: uppercase;
            line-height: 1;
            padding: 9px 11px;
            margin: 3px 10px 7px 3px;
            font-size: 0.86667em;
            font-style: normal;
            border: 1px solid #d2d2d2;
            color: #222323;
            cursor: pointer;
          }
          input {
            // display: none;
            clip: rect(0, 0, 0, 0);
            overflow: hidden;
            position: absolute;
            height: 1px;
            width: 1px;
            // &:focus + label,
            // &:active + label {
            //   background-color: #f2f2f2;
            // }
          }
          select {
            max-width: 100%;
            outline: none;
            font-size: 1.2em;
            border-color: transparent;
            color: #1c1d1d;
            padding: 8px 28px 8px 10px;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            background: #f6f6f6 url('~@/images/downward1.png') no-repeat right 5px center;
            background-size: 10px;
            &:hover {
              outline: 1px solid #dddddd;
            }
          }

          .active {
            // border: 1px solid var(--main-btn-bg);
            background-color: var(--main-btn-bg);
            border-color: var(--main-btn-bg);
            color: var(--main-btn-tx);
          }
        }

        .addcart {
          // margin-bottom: 40px;
          form {
            width: 100%;
            .gocart {
              display: inline-block;
              width: 100%;
              height: 48px;
              padding: 12px 30px;
              background: #c90d0d;
              // background: rgb(201, 13, 13);
              color: #fff;
              border: 1px solid #c90d0d;
              border-radius: 0;
              text-transform: uppercase;
              &:hover {
                background: rgb(241, 34, 34);
              }
              .iconfont {
                margin-right: 10px;
              }
            }
            .buynow {
              width: 100%;
              background-color: #111112;
              color: #e6e6e7;
              text-align: center;
              font-size: 13px;
              font-family: 'Oswald', sans-serif;
              height: 44px;
              letter-spacing: 1px;
              cursor: pointer;
              margin: 10px 0 0 0 !important;
              border-radius: 0;
              text-transform: uppercase;
              &:hover {
                opacity: 0.9;
              }
            }
            .soldout {
              background: #f6f6f6 !important;
              color: #717171 !important;
              border: none;
              margin: 20px 0 0px;
              border: 1px solid #717171 !important;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 575px) {
  .commodityname {
    font-size: 30px !important;
    font-weight: normal !important;
  }
  .commoditydetail {
    margin-top: 0 !important;
    // .quickPurchased {
    //   .quick_right {
    //     width: 100vw !important;
    //     max-width: 100vw !important;
    //     .sm_button {
    //       height: 56px !important;
    //       width: 100vw !important;
    //       margin-left: 22px !important;
    //       margin-top: -8px !important;
    //       margin-bottom: -8px !important;
    //     }
    //   }
    // }
  }
}
.v-product{
  .guess_like {
    .guess_list_wrap {
      @media screen and(max-width: 1275px) {
        & > .prev {
          left: -15px;
        }
        & > .next {
          right: -15px;
        }
      }
      @media screen and(max-width: 1160px) {
        & > .prev {
          left: 5px;
        }
        & > .next {
          right: 5px;
        }
      }
    }
  }
}
</style>
